module.exports = __webpack_public_path__ + "static/Zeugnisprozess_Release_3_4_9-497a20135ff448071c219738a55031b1.pdf";